import { render, staticRenderFns } from "./SecurityReport.vue?vue&type=template&id=31883fb5&scoped=true&"
import script from "./SecurityReport.vue?vue&type=script&lang=ts&"
export * from "./SecurityReport.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityReport.vue?vue&type=style&index=0&id=31883fb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31883fb5",
  null
  
)

export default component.exports